import { useEffect, useState } from 'react';

/**
 * @template T return value
 * @template R default value
 * @param {() => Promise<T>} fn useCallback'd function to memoize
 * @param {R} defaultValue=null
 * @returns {T | R}
 * Memoizes the result of an arbitrary asynchronous function (which should be passed using `useCallback()`)
 */
export const useMemoAsync = (fn, defaultValue = null) => {
  const [result, setResult] = useState(defaultValue);

  useEffect(() => {
    let ignore = false;
    fn().then((res) => !ignore && setResult(res));
    return () => {
      ignore = true;
    };
  }, [fn]);

  return result;
};
